import React from 'react';
import { splitForensicJargon } from '../config/forensicJargon';

export default function ForensicJargonText({ text }) {
    if (!text) return null;
    const parts = splitForensicJargon(text);
    return (
        <>
            {parts.map((part, index) => (
                part.definition ? (
                    <span
                        key={`${part.text}-${index}`}
                        className="forensic-jargon"
                        tabIndex={0}
                        data-tip={part.definition}
                        aria-label={`${part.text}: ${part.definition}`}
                    >
                        {part.text}
                    </span>
                ) : (
                    <React.Fragment key={`${part.text}-${index}`}>{part.text}</React.Fragment>
                )
            ))}
        </>
    );
}
